var main = require('client_core/main');
main.baseFiles.menu = require('./components/menu');
module.exports = main;